import { Dispatch, SetStateAction, useState } from 'react';

import { ICompanyPart, ICost } from 'partsOld/types';

import CostingHeaderView from './CostingHeaderView';

interface IProps {
  part?: Partial<ICompanyPart>;
  selectedCost?: ICost;
  setSelectedCost: Dispatch<SetStateAction<ICost>>;
}

const CostingHeader = ({ part, selectedCost, setSelectedCost }: IProps) => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <CostingHeaderView
      part={part}
      selectedCost={selectedCost}
      setSelectedCost={setSelectedCost}
      isFormOpen={isFormOpen}
      setIsFormOpen={setIsFormOpen}
    />
  );
};

export default CostingHeader;
